import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

export const AchieveDialog = ({ open, onOpenChange, interest, beneficiary, onBeneficiaryChange, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-['Manrope']">Achievement!</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-muted-foreground">
            Great job completing <span className="font-semibold text-foreground">"{interest?.title}"</span>!
          </p>
          <div className="space-y-2">
            <Label>This achievement benefitted:</Label>
            <RadioGroup value={beneficiary} onValueChange={onBeneficiaryChange} className="space-y-2">
              <Label className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-muted [&:has(:checked)]:border-primary [&:has(:checked)]:bg-primary/5">
                <RadioGroupItem value="me" />
                <span>Me personally</span>
              </Label>
              <Label className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-muted [&:has(:checked)]:border-primary [&:has(:checked)]:bg-primary/5">
                <RadioGroupItem value="work" />
                <span>My work</span>
              </Label>
              <Label className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-muted [&:has(:checked)]:border-primary [&:has(:checked)]:bg-primary/5">
                <RadioGroupItem value="others" />
                <span>Someone else</span>
              </Label>
              <Label className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-muted [&:has(:checked)]:border-primary [&:has(:checked)]:bg-primary/5">
                <RadioGroupItem value="no_one" />
                <span>No one</span>
              </Label>
            </RadioGroup>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSubmit} data-testid="confirm-achievement-btn">Complete Achievement</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
